export default "__VITE_PUBLIC_ASSET__ed9662a7__"